
import { FormattedMessage } from 'react-intl';
import { Backdrop, Typography, Box, useTheme } from '@mui/material';
import { LoadingDrop } from 'components';

export default function PageLoading(props) {
    const { messageId } = props;
    const theme = useTheme();
   
    return (
        <Backdrop open sx={{ color: theme.palette.background.paper, zIndex: (theme) => theme.zIndex.drawer + 1, bgcolor: theme.palette.primary.main }} >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <LoadingDrop />
                {messageId && <Typography className='jello-horizontal' variant="body1" color="inherit">
                    <FormattedMessage id={messageId} />
                </Typography>}
            </Box>
        </Backdrop>
    );
}